import React from "react";
import Header from "./components/Header";
import Hero from "./components/Hero";
import About from "./components/About";
import Qualifications from "./components/Qualifications";
import Services from "./components/Services";
import Research from "./components/Research";
import Testimonials from "./components/Testimonials";
import Contact from "./components/Contact";
import Footer from "./components/Footer";


import "./App.css";

function App() {
  return (
    <div>
      <Header />
      <Hero />
      <About />
      <Qualifications /> 
      <Services />
      <Research />
      <Testimonials />
      <Contact />
      <Footer />
    </div>
  );
}

export default App;
